export default {
    createBillboardMessage: 'สร้างข้อความประกาศ',
    createIndividualMessage: 'สร้างข้อความรายบุคคล',
    updateBillboardMessage: 'แก้ไขข้อความประกาศ',
    updateIndividualMessage: 'แก้ไขข้อความรายบุคคล',
    startDate: 'วันที่เริ่ม',
    endDate: 'วันที่สิ้นสุด',
    topic: 'หัวข้อ',
    employeeNo: 'รหัสพนักงาน',
    description: 'คำอธิบาย',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    msgRequiredField: 'กรุณากรอกข้อมูล',
    msgExceededField: 'ข้อความเกิน 255 ตัวอักษร',
    msgError: 'เกิดข้อผิดพลาด',
    congratulation: 'ยินดีด้วย',
    msgErrorUpload: 'อัพโหลดเกิดข้อผิดพลาด',
    msgErrorUploadImageFail: 'อัพโหลดรูปภาพผิดพลาด',
    msgErrorSizeUpload: 'รูปภาพ (.jpg,.jpeg,.png,.gif) เท่านั้นเเละไฟล์ขนาดต้องต่ำกว่า 10 MB',
    msgCreateSuccess: 'ข้อความ "$Name" ถูกสร้างเเล้ว',
    msgUpdateSuccess: 'ข้อความ "$Name" ถูกอัปเดตเเล้ว'
}
